import type { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { Box, IconButton, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import type { CostCenter } from "../models/CostCenter";
import { activeColumnDef } from "@/controls/ag-grid/components/ActiveColumn";

interface UseTableDataProps {
	onDelete: (costCenter: CostCenter) => void;
}

export const useTableData = ({ onDelete }: UseTableDataProps) => {
	const columnDefs: ColDef<CostCenter>[] = [
		{
			field: "Name",
			headerName: "Name",
			flex: 2,
			sortable: true,
			filter: true,
		},
		{
			field: "Description",
			headerName: "Description",
			flex: 1.5,
			sortable: true,
			filter: true,
		},
		{
			field: "Bud",
			headerName: "Bud",
			flex: 0.8,
			sortable: true,
			filter: true,
		},
		{
			field: "DeptId",
			headerName: "Dept Id",
			flex: 1,
			sortable: true,
			filter: true,
		},
		{
			field: "EndUser",
			headerName: "End User",
			flex: 1,
			sortable: true,
			filter: true,
		},
		activeColumnDef<CostCenter>(),
		{
			headerName: "",
			width: 60,
			minWidth: 60,
			maxWidth: 60,
			sortable: false,
			filter: false,
			resizable: false,
			suppressSizeToFit: true,
			cellRenderer: (params: ICellRendererParams<CostCenter>) => {
				if (!params.data) return null;
				return (
					<Box
						sx={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							height: "100%",
						}}
					>
						<Tooltip title="Delete">
							<IconButton
								size="small"
								onClick={(e) => {
									e.stopPropagation();
									onDelete(params.data as CostCenter);
								}}
								color="error"
								sx={{ p: 0.25 }}
							>
								<DeleteIcon fontSize="small" />
							</IconButton>
						</Tooltip>
					</Box>
				);
			},
		},
	];

	return { columnDefs };
};
